import { useMutation, useQuery } from 'react-query'

import { QueryKey } from '../../../common/api'
import { organizationApi } from '../api/organization.api'
import { CreateOrganizationDto } from '../types/organization.types'

export const useGetOrganization = (id?: number) => {
  return useQuery(
    [QueryKey.Organization, id],
    async () => {
      if (!id) {
        return null
      }

      const organization = await organizationApi.getById(id)

      return organization.data
    },
    {
      enabled: !!id,
    },
  )
}

export const useCreateOrganization = () => {
  return useMutation((organization: CreateOrganizationDto) => {
    return organizationApi.create(organization)
  })
}

export const useCheckOrganization = () => {
  return useMutation(async (ogrn: string) => {
    const response = await organizationApi.checkIsExist(ogrn)

    return response.data
  })
}

export const useUpdateOrganization = () => {}

export const useListOrganizations = () => {}
